import { DatePickerInput } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useAccount from '@ubeya/shared/hooks/account/useAccount';
import useFields from '@ubeya/shared/hooks/account/useFields';
import moment from 'moment';
import React, { useCallback, useContext, useMemo, useState } from 'react';
import styled from 'styled-components';
import ConfirmationModal from '@ubeya/shared-web/components/ConfirmationModal';
import useToaster from '@ubeya/shared/hooks/useToaster';
import { TERMINATION_DATE_FIELD } from 'employees/constants';
const Description = styled.div`
  margin-bottom: 10px;
`;

const DeleteEmployeeModal = ({ onClose, employeeFields, employee: { id, firstName, lastName }, updateEmployee }) => {
  const { t } = useContext(ConfigContext);
  const { accountId } = useAccount();
  const { addResponseError } = useToaster();

  const { fields } = useFields();
  const terminationDateField = useMemo(() => fields.find(({ slug }) => slug === TERMINATION_DATE_FIELD), [fields]);

  const [terminationDate, setTerminationDate] = useState(
    employeeFields[terminationDateField?.id] ||
      employeeFields[`field-${terminationDateField?.id}`] ||
      moment().add('days', 1)
  );

  const [isLodaing, setIsLoading] = useState(false);

  const onConfirm = useCallback(async () => {
    setIsLoading(true);
    try {
      const newFields =
        terminationDate && terminationDateField ? [{ id: terminationDateField.id, value: terminationDate }] : [];

      const updateParams = { fields: newFields, accountId, employeeId: id, isDeleted: true };
      await updateEmployee(updateParams);
    } catch (e) {
      addResponseError(e);
    } finally {
      setIsLoading(false);
      onClose();
    }
  }, [accountId, addResponseError, id, onClose, terminationDate, terminationDateField, updateEmployee]);

  return (
    <ConfirmationModal
      title={t('areYouSureDeleteEmployeeName', { name: `${firstName} ${lastName}` })}
      confirmText={t('delete')}
      onConfirm={onConfirm}
      loadingConfirm={isLodaing}
      onClose={onClose}
      isPermanentAction
      warnings={[t('employeeDeleteFutureEventsWarning')]}
      usePortal>
      <Description>{t('setEmploymentTerminationDate')}</Description>
      <DatePickerInput innerStyle="z-index: 8;" value={terminationDate} onChange={setTerminationDate} />
    </ConfirmationModal>
  );
};
export default DeleteEmployeeModal;
